import { useCallback, useEffect } from "react";
import type { FormValues } from "../../../common/types/formTypes";
import persistedFormStore from "../../../stores/persistedFormStore";

export const useFormPersistence = (
   formValues: FormValues,
   setFormValues: (values: FormValues) => void,
   persistenceKey?: string
) => {
   useEffect(() => {
      if (persistenceKey) {
         const existingData = persistedFormStore.getFormData(persistenceKey);
         if (existingData) {
            setFormValues(existingData);
         }
      }
   }, [persistenceKey, setFormValues]);

   useEffect(() => {
      if (persistenceKey) {
         persistedFormStore.setFormData(persistenceKey, formValues);
      }
   }, [formValues, persistenceKey]);

   const clearFormPersistence = useCallback(() => {
      if (persistenceKey) {
         persistedFormStore.clearFormData(persistenceKey);
      }
   }, [persistenceKey]);

   return { clearFormPersistence };
};
